// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","Pomegranate":"#FF0032","Blueberry":"#3E3AC2","intro":"G5aeb8c","main":"Gfb637f","text":"G36e8db"};